import React from 'react';
import { MatrixRain } from './screensavers/MatrixRain';
import { SpaceInvaders } from './screensavers/SpaceInvaders';
import { Starfield } from './screensavers/Starfield';
import { BouncingLogo } from './screensavers/BouncingLogo';
import { RetroTerminal } from './screensavers/RetroTerminal';
import { FloatingText } from './screensavers/FloatingText';
import { Pipes } from './screensavers/Pipes';
import { DigitalClock } from './screensavers/DigitalClock';
import { DiskDefrag } from './screensavers/DiskDefrag';
import { useUserSettings } from '../hooks/useUserSettings';

interface ScreensaverProps {
  onActivity: () => void;
}

export type ScreensaverType = 'none' | 'bouncing' | 'matrix' | 'invaders' | 'starfield' | 'terminal' | 'floating-text' | 'pipes' | 'digital-clock' | 'disk-defrag';

export const Screensaver: React.FC<ScreensaverProps> = ({ onActivity }) => {
  // Load from Supabase-backed display settings
  const { settings, isLoaded } = useUserSettings('display', {
    screensaverType: 'bouncing',
  });

  const type: ScreensaverType = (settings?.screensaverType as ScreensaverType) || 'bouncing';

  if (!isLoaded) {
    return null;
  }

  switch (type) {
    case 'none':
      return null;
    case 'matrix':
      return <MatrixRain onActivity={onActivity} />;
    case 'invaders':
      return <SpaceInvaders onActivity={onActivity} />;
    case 'starfield':
      return <Starfield onActivity={onActivity} />;
    case 'terminal':
      return <RetroTerminal onActivity={onActivity} />;
    case 'floating-text':
      return <FloatingText onActivity={onActivity} />;
    case 'pipes':
      return <Pipes onActivity={onActivity} />;
    case 'digital-clock':
      return <DigitalClock onActivity={onActivity} />;
    case 'disk-defrag':
      return <DiskDefrag onActivity={onActivity} />;
    case 'bouncing':
    default:
      return <BouncingLogo onActivity={onActivity} />;
  }
};